
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ElementStyleActionsProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a element style action provider for the purpose of contributing a element style action
 */
/**
 * @typedef {object} ElementStylePayload
 * @memberof ElementStyleActionsAPI
 * @property {string} customType the type of custom data
 * @property {object[]} properties consist of a list of key/value pairs
 */

/**
 * @typedef {object} ElementStyle
 * @memberof ElementStyleActionsAPI
 * @property {string} key  the category of a element style, eg. value axis lables;
 * @property {string} type the type of the data, should always be 'customdata'
 * @property {ElementStylePayload[]} values, the payload of the element style
 */
define([], () => {
	class ElementStyleActionsProviderAPI {

		/**
		* @function ElementStyleActionsProviderAPI#getElementStyleActionList
		* @description Returns a list of ElementStyleActions available for array of element styles.
		* @param {ElementStyle[]} elementStyles: a list of element style object , an element style object is the item in visualization that can be manipulated with a set of properties,
		* the element style object could also be an element title
		* @return {object[]} array containing all available actions
		*/
		getElementStyleActionList(/*elementStyles  */) {}

	}

	return ElementStyleActionsProviderAPI;
});